import auth from "./auth"

const permission = {
    getPermissions() {
        const user = auth.getUserInfo()
        return user?.permissions || {}
    },

    getEndpointMethods(endpoint) {
        const permissions = this.getPermissions()
        return permissions[endpoint] || []
    },

    can(endpoint, method) {
        const methods = this.getEndpointMethods(endpoint)
        return methods.includes(method)
    },

    canAccess(endpoint) {
        const methods = this.getEndpointMethods(endpoint)
        return methods.length > 0
    },

    canGet(endpoint) {
        return this.can(endpoint, "get")
    },

    canPost(endpoint) {
        return this.can(endpoint, "post")
    },

    canPatch(endpoint) {
        return this.can(endpoint, "patch")
    },

    canDelete(endpoint) {
        return this.can(endpoint, "delete")
    },

    getAll(endpoint) {
        const methods = this.getEndpointMethods(endpoint)

        return {
            get: methods.includes("get"),
            post: methods.includes("post"),
            patch: methods.includes("patch"),
            delete: methods.includes("delete")
        }
    },

    getAllFromEndpoints(endpoints) {
        const methods = {
            get: false,
            post: false,
            patch: false,
            delete: false
        }

        endpoints.forEach(endpoint => {
            const endpointMethods = this.getEndpointMethods(endpoint)

            endpointMethods.forEach(method => {
                methods[method] = true
            })
        })

        return methods
    },

    canAny(endpoints, method = null) {
        return endpoints.some(endpoint => {
            const methods = this.getEndpointMethods(endpoint)

            if (!method) return methods.length > 0

            return methods.includes(method)
        })
    }

}

export default permission